import axios from '@/utils/axios';

/**
 * Quote Label 관련 API 서비스
 */
const quoteLabelService = {
  /**
   * 내 라벨 목록 조회
   */
  async getMyLabels() {
    try {
      const data = await axios.get('/api/v1/quote/label');
      return data;
    } catch (error) {
      console.error('라벨 목록 조회 실패:', error);
      throw error;
    }
  },

  /**
   * 라벨 생성
   */
  async createLabel(name, colorCode) {
    try {
      const data = await axios.post('/api/v1/quote/label', {
        name,
        colorCode,
      });
      return data;
    } catch (error) {
      console.error('라벨 생성 실패:', error);
      throw error;
    }
  },

  /**
   * 라벨 수정
   */
  async updateLabel(labelId, name, colorCode) {
    try {
      const data = await axios.put(`/api/v1/quote/label/${labelId}`, {
        name,
        colorCode,
      });
      return data;
    } catch (error) {
      console.error('라벨 수정 실패:', error);
      throw error;
    }
  },

  /**
   * 라벨 삭제
   */
  async deleteLabel(labelId) {
    try {
      await axios.delete(`/api/v1/quote/label/${labelId}`);
    } catch (error) {
      console.error('라벨 삭제 실패:', error);
      throw error;
    }
  },

  /**
   * 호가에 라벨 추가
   */
  async addLabelToQuote(labelId, creditQuoteId) {
    try {
      await axios.post(`/api/v1/quote/label/${labelId}/item`, {
        creditQuoteId,
      });
    } catch (error) {
      console.error('라벨 추가 실패:', error);
      throw error;
    }
  },

  /**
   * 호가에서 라벨 제거
   */
  async removeLabelFromQuote(labelId, creditQuoteId) {
    try {
      await axios.delete(`/api/v1/quote/label/${labelId}/item/${creditQuoteId}`);
    } catch (error) {
      console.error('라벨 제거 실패:', error);
      throw error;
    }
  },

  /**
   * 특정 호가의 라벨 목록 조회
   */
  async getLabelsForQuote(creditQuoteId) {
    try {
      const data = await axios.get(`/api/v1/quote/label/item/${creditQuoteId}`);
      return data;
    } catch (error) {
      console.error('호가 라벨 조회 실패:', error);
      throw error;
    }
  },
};

export default quoteLabelService;

